<template>
  <div class="wrapper-variables">
    <div class="variable-list">
      <div
        v-for="(variable, index) in adminVariables"
        :key="index"
        class="variable-info"
      >
        <v-text-field
          label="Chave"
          outlined
          dense
          single-line
          hide-details
          height="40"
          v-model="variable.key"
        ></v-text-field>
        <v-text-field
          label="Valor"
          outlined
          dense
          hide-details
          height="40"
          single-line
          v-model="variable.value"
        ></v-text-field>
      </div>
    </div>
    <v-btn
      color="primary"
      height="40"
      class="save-variables-button"
      @click="handleSave"
      >Salvar</v-btn
    >
  </div>
</template>

<script>
export default {
  name: 'Variables',
  props: {
    adminVariables: Array,
  },
  methods: {
    handleSave() {
      this.$store.dispatch('admin/updateAdminVariables', this.adminVariables);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/theme.scss';

.wrapper-variables {
  width: 600px;
  height: calc(100vh - 180px);

  .variable-list {
    max-height: calc(100vh - 208px);
    overflow: auto;
    margin-bottom: 8px;

    .variable-info {
      display: flex;
      margin-bottom: 8px;
      width: 100%;

      .v-text-field {
        margin: 0 4px;
      }
    }
  }

  .save-variables-button {
    position: absolute;
    right: 0;
    margin-right: 4px;
  }
}
</style>
